import React, { createContext, useState } from 'react'

export const UserContext = createContext({
    adminList: [],
    loggedInUser : {},
    handleUsers: () => {},
    handleLoggedInUser: () => {}

})

const UserContextProvider = ({children}) => {
    const [adminList, setAdminList] = useState([])
    const [currentRole, setCurrentRole] = useState({})
    const handleLoggedInUser = (role) => {
      setCurrentRole(role)
    }
    const handleUser = (users) => {
      setAdminList(users)
    }

  return (
    <UserContext.Provider value={{adminList: adminList, handleUsers: handleUser, loggedInUser: currentRole, handleLoggedInUser: handleLoggedInUser}}>
        {children}
    </UserContext.Provider>
  )
}

export default UserContextProvider